module.exports = __webpack_public_path__ + "static/profile-a616db09d506413c9f5a36327799ba7b.jpg";